import type { HTMLAttributes } from "react";

import { DefinedDefaults, TWithDataComponent } from "@/ui/lib";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const AVAILABLE_CONTAINER_TAGS = [ "div", "main", "section", "article", "header", "footer", "nav", "aside" ] as const;

export const CONTAINER_SIZE_CLASS_MAP = {
  default: "",
  md: "max-w-[1024px]",
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

type TContainerTag = typeof AVAILABLE_CONTAINER_TAGS[number];
type TContainerSize = keyof typeof CONTAINER_SIZE_CLASS_MAP;

export type TContainerProps = {
  tag?: TContainerTag;
  size?: TContainerSize;
} & TWithDataComponent & HTMLAttributes<HTMLElement>;

type TContainerDefaultProps = DefinedDefaults<
  TContainerProps,
  "tag" | "data-component" | "size"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const CONTAINER_DEFAULTS = {
  tag: "div",
  "data-component": "Container",
  size: "default",
} satisfies TContainerDefaultProps;
